import * as React from "react"
import * as Antd from "antd"
import styles from "./AppText.module.scss"

import { AppConfig } from "@constants/AppConfig.ts"
import { useTranslation } from "react-i18next"

export interface IAppTextProps {
	className?: string
	tag?: "h1" | "h2" | "h3" | "h4" | "h5" | "h6" | "p" | "span"
	textKey?: string
	children?: string
	ellipsis?: boolean
}

const AppText: React.FC<IAppTextProps> = (props) => {
	const { t } = useTranslation()
	const textRef = React.useRef<HTMLParagraphElement>(null)
	const [isOverflowing, setIsOverflowing] = React.useState(false)

	React.useEffect(() => {
		if (!textRef.current || !props.ellipsis) return

		const resizeObserver = new ResizeObserver(() => {
			setIsOverflowing(
				textRef.current!.scrollWidth > textRef.current!.clientWidth
			)
		})

		resizeObserver.observe(textRef.current!)

		return () => resizeObserver.disconnect()
	}, [])

	const Wrapper = props.tag || "p"

	return (
		<Antd.Tooltip
			title={isOverflowing ? props.children : undefined}
			placement={"topRight"}
		>
			<Wrapper
				ref={textRef}
				className={`${styles.app_text} ${props.ellipsis ? styles.ellipsis : ""} ${props.className || ""}`}
			>
				{props.textKey
					? t(props.textKey)
					: props.children || AppConfig.APP_NOT_VALUE}
			</Wrapper>
		</Antd.Tooltip>
	)
}

export default React.memo(AppText)
